/* PES Collection UI v6 — Sidebar Fix + Enhanced Filters */
(function(){'use strict';

/* ========== SORT DROPDOWN ========== */
var sortLabels={
'best-selling':'Best Selling',
'price-ascending':'Price: Low to High',
'price-descending':'Price: High to Low',
'title-ascending':'Name: A to Z',
'title-descending':'Name: Z to A',
'created-ascending':'Date: Old to New',
'created-descending':'Date: New to Old',
'manual':'Featured'
};

function initSortDropdown(){
var existing=document.getElementById('pes-sort-select');
if(existing)return;
var toolbar=document.querySelector('.facets-vertical-sort, .collection-toolbar, .product-grid-container, .custm-mn-topslder');
if(!toolbar)return;
var sortWrap=document.createElement('div');
sortWrap.className='pes-sort-wrap';
sortWrap.style.cssText='display:flex;align-items:center;gap:8px;margin:0 0 0 auto;';
var label=document.createElement('span');
label.className='pes-sort-label';
label.textContent='Sort:';
label.style.cssText='font-size:13px;color:#666;font-weight:500;';
var select=document.createElement('select');
select.id='pes-sort-select';
select.className='pes-sort-select';
select.style.cssText='padding:6px 28px 6px 12px;border:1px solid #ddd;border-radius:6px;font-size:14px;background:#fff;color:#333;cursor:pointer;';
var currentSort=new URLSearchParams(window.location.search).get('sort_by')||'best-selling';
Object.keys(sortLabels).forEach(function(key){
var opt=document.createElement('option');
opt.value=key;
opt.textContent=sortLabels[key];
if(key===currentSort)opt.selected=true;
select.appendChild(opt);
});
select.addEventListener('change',function(){
var url=new URL(window.location.href);
url.searchParams.set('sort_by',select.value);
window.location.href=url.toString();
});
sortWrap.appendChild(label);
sortWrap.appendChild(select);
var targetEl=toolbar.querySelector('.facets-vertical-sort, .facet-filters__sort');
if(targetEl){targetEl.appendChild(sortWrap);}
else{toolbar.insertBefore(sortWrap,toolbar.firstChild);}
}

/* ========== CSS INJECTION ========== */
var css=`
/* === LAYOUT FIX: Show sidebar as left column === */
.cust-desktop-sortfilter{
  display:block!important;
  width:260px!important;
  min-width:260px!important;
  flex-shrink:0!important;
  position:sticky!important;
  top:80px!important;
  max-height:calc(100vh - 100px)!important;
  overflow-y:auto!important;
  padding-right:8px;
}
.cstm-collect-facets-container.facets-vertical{
  display:flex!important;
  gap:24px!important;
  align-items:flex-start!important;
}
.collection_main_grid{
  flex:1!important;
  min-width:0!important;
}
/* Hide native sort (we have our own) */
.facet-filters.sorting,
.cust-desktop-sortfilter .facet-filters__sort,
.cust-desktop-sortfilter .select,
#SortBy,
#FacetSortForm{
  display:none!important;
}
/* Hide native facet checkboxes */
.facet-checkbox{display:none!important}

/* === SIDEBAR STYLING === */
.pes-sidebar{
  background:#fff;
  border:1px solid #e5e5e5;
  border-radius:8px;
  padding:0 16px 16px;
}
.pes-sidebar-title{
  font-size:16px;
  font-weight:700;
  color:#0f1e2d;
  margin:0;
  padding:16px 0 12px;
  border-bottom:2px solid #11B67B;
  display:flex;
  align-items:center;
  justify-content:space-between;
}
.pes-sidebar-title span{font-size:12px;color:#999;font-weight:400;}
.pes-filter-group{
  border-bottom:1px solid #eee;
  padding:12px 0;
}
.pes-filter-group:last-child{border-bottom:none;}
.pes-filter-group-header{
  font-size:13px;
  font-weight:700;
  text-transform:uppercase;
  letter-spacing:.5px;
  color:#333;
  margin:0 0 8px;
  cursor:pointer;
  display:flex;
  justify-content:space-between;
  align-items:center;
  user-select:none;
}
.pes-filter-group-header .toggle{
  width:20px;
  height:20px;
  display:flex;
  align-items:center;
  justify-content:center;
  font-size:16px;
  color:#999;
  transition:transform .2s;
}
.pes-filter-group.collapsed .toggle{transform:rotate(-90deg);}
.pes-filter-group.collapsed .pes-filter-list{display:none;}
.pes-filter-list{
  list-style:none;
  padding:0;
  margin:0;
}
.pes-filter-list li{margin-bottom:2px;}
.pes-filter-list a{
  font-size:13px;
  color:#555;
  text-decoration:none;
  padding:6px 8px;
  display:block;
  border-radius:4px;
  transition:all .15s;
  position:relative;
}
.pes-filter-list a:hover{
  background:#f5f5f5;
  color:#11B67B;
}
.pes-filter-list a.active{
  background:#e8f7f0;
  color:#11B67B;
  font-weight:600;
}
.pes-filter-list a .count{
  font-size:11px;
  color:#999;
  margin-left:4px;
}

/* === ACTIVE FILTER CHIPS === */
.pes-active-filters{
  display:flex;
  flex-wrap:wrap;
  gap:6px;
  margin-bottom:12px;
  padding-top:8px;
}
.pes-filter-chip{
  background:#11B67B;
  color:#fff;
  padding:4px 10px;
  border-radius:12px;
  font-size:12px;
  font-weight:500;
  display:inline-flex;
  align-items:center;
  gap:4px;
  cursor:pointer;
  text-decoration:none;
  border:none;
}
.pes-filter-chip:hover{background:#0d9460;}
.pes-filter-chip .x{font-size:14px;margin-left:2px;font-weight:700;}
.pes-clear-all{
  font-size:12px;
  color:#999;
  text-decoration:underline;
  cursor:pointer;
  background:none;
  border:none;
  padding:4px 8px;
}

/* === PRICE SLIDER === */
.pes-price-inputs{
  display:flex;
  align-items:center;
  gap:8px;
  margin-top:8px;
}
.pes-price-inputs input{
  width:80px;
  padding:6px 8px;
  border:1px solid #ddd;
  border-radius:4px;
  font-size:13px;
}
.pes-price-inputs .sep{color:#999;font-size:13px;}
.pes-price-go{
  padding:6px 12px;
  background:#11B67B;
  color:#fff;
  border:none;
  border-radius:4px;
  font-size:13px;
  cursor:pointer;
  font-weight:600;
}
.pes-price-go:hover{background:#0d9460;}

/* === BROWSE BUBBLE HIDE === */
.pes-browse-bubble,.browse-collection-bubble,[class*="browse"][class*="bubble"],
.browse-all-categories,[class*="Browse this collection"]{display:none!important}
a[href*="browse"][class*="bubble"]{display:none!important}
.custm-mn-topslder .mblfitlers a[href*="browse"]{display:none!important}

/* === MOBILE (defer entirely to pes-collection-filters.js drawer, breakpoint 989px) === */
@media(max-width:989px){
  .cust-desktop-sortfilter{
    display:none!important;
  }
}

/* === MOBILE BOTTOM-SHEET FILTERS (<=768px) — owned by this script (Agent-8, Task B) ===
   Supersedes the legacy side drawer from pes-collection-filters.js at <=768px only;
   769-989px still uses the legacy drawer. */
.pes-bs-bar{display:none;}
@media(max-width:768px){
  .pes-mobile-filter-bar,.pes-filter-drawer,.pes-filter-overlay{display:none!important;}
  .pes-bs-bar{display:flex!important;margin:0 0 12px;padding:0 4px;}
}
.pes-bs-btn{display:inline-flex;align-items:center;gap:8px;background:#0f1e2d;color:#fff;border:none;border-radius:8px;padding:10px 16px;font-size:14px;font-weight:700;cursor:pointer;font-family:inherit;}
.pes-bs-btn svg{width:16px;height:16px;flex-shrink:0;}
.pes-bs-badge{background:#11B67B;color:#fff;font-size:11px;font-weight:800;min-width:18px;height:18px;border-radius:9px;display:inline-flex;align-items:center;justify-content:center;padding:0 5px;}
.pes-bs-scrim{position:fixed;inset:0;background:rgba(15,30,45,0.55);z-index:10001;opacity:0;pointer-events:none;transition:opacity .25s;}
.pes-bs-scrim.open{opacity:1;pointer-events:auto;}
.pes-bs-sheet{position:fixed;left:0;right:0;bottom:0;z-index:10002;background:#fff;border-radius:16px 16px 0 0;max-height:84vh;display:flex;flex-direction:column;transform:translateY(103%);transition:transform .3s ease;box-shadow:0 -12px 40px rgba(0,0,0,0.3);}
.pes-bs-sheet.open{transform:translateY(0);}
.pes-bs-head{display:flex;align-items:center;justify-content:space-between;padding:14px 18px;border-bottom:1px solid #eee;flex:0 0 auto;}
.pes-bs-head h2{font-size:16px;font-weight:800;color:#0f1e2d;margin:0;}
.pes-bs-close{background:none;border:none;font-size:26px;line-height:1;cursor:pointer;color:#666;padding:2px 8px;}
.pes-bs-body{overflow-y:auto;-webkit-overflow-scrolling:touch;padding:8px 18px 18px;flex:1 1 auto;}
.pes-bs-group{padding:10px 0;border-bottom:1px solid #eee;}
.pes-bs-group:last-child{border-bottom:none;}
.pes-bs-group-name{font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:.6px;color:#333;margin:0 0 8px;}
.pes-bs-list{list-style:none;margin:0;padding:0;}
.pes-bs-list li{margin-bottom:2px;}
.pes-bs-opt{display:flex;align-items:center;justify-content:space-between;gap:8px;width:100%;background:none;border:none;text-align:left;font-size:15px;color:#444;padding:10px;border-radius:8px;cursor:pointer;font-family:inherit;}
.pes-bs-opt .cnt{font-size:12px;color:#999;font-weight:400;}
.pes-bs-opt.selected{background:#e8f7f0;color:#11B67B;font-weight:700;}
.pes-bs-opt.selected .cnt{color:#0d8f62;}
.pes-bs-price-inputs{display:flex;align-items:center;gap:8px;padding:6px 0 2px;}
.pes-bs-price-inputs input{flex:1;min-width:0;padding:9px 10px;border:1px solid #ddd;border-radius:6px;font-size:14px;}
.pes-bs-price-inputs .sep{color:#999;font-size:13px;}
.pes-bs-foot{display:flex;gap:10px;padding:14px 18px;border-top:1px solid #eee;flex:0 0 auto;}
.pes-bs-clear{flex:1;background:#fff;border:1px solid #ddd;border-radius:8px;padding:12px;font-size:14px;font-weight:700;color:#555;cursor:pointer;font-family:inherit;}
.pes-bs-apply{flex:2;background:#11B67B;border:none;border-radius:8px;padding:12px;font-size:14px;font-weight:800;color:#fff;cursor:pointer;font-family:inherit;}
.pes-bs-apply:hover{background:#0d9460;}
@media(min-width:769px){
  .pes-bs-bar,.pes-bs-scrim,.pes-bs-sheet{display:none!important;}
}
body.pes-bs-locked{overflow:hidden;}
`;

function injectCSS(){
var style=document.createElement('style');
style.textContent=css;
document.head.appendChild(style);
}

/* ========== ENHANCED FILTER SIDEBAR ========== */
function buildSidebar(){
var container=document.querySelector('.facets-container')||document.querySelector('.cust-desktop-sortfilter');
if(!container)return;
// Remove old fallback filters
var old=container.querySelector('.pes-fallback-filters, .pes-sidebar');
if(old)old.remove();

var m=window.location.pathname.match(/\/collections\/([^\/\?]+)/);
if(!m)return;
var handle=m[1];

// Get current URL params for active filter detection
var params=new URLSearchParams(window.location.search);
var activeVendor=params.get('filter.p.vendor');
var activePriceGte=params.get('filter.v.price.gte');
var activePriceLte=params.get('filter.v.price.lte');

// Dynamic per-collection filter config (2026-08-04 rework)
// Replaces the hardcoded 7-collection map: vendors + product types are
// computed live from the collection's own products, so every one of the
// 300+ collections gets accurate Brand/Type groups automatically.
var priceMap={
'solar-panels':[['Under $150',null,'150'],['$150 – $250','150','250'],['$250 – $350','250','350'],['$350 – $500','350','500'],['$500+','500',null]],
'inverters':[['Under $500',null,'500'],['$500 – $1,000','500','1000'],['$1,000 – $2,000','1000','2000'],['$2,000 – $5,000','2000','5000'],['$5,000+','5000',null]],
'batteries-energy-storage':[['Under $1,000',null,'1000'],['$1,000 – $3,000','1000','3000'],['$3,000 – $5,000','3000','5000'],['$5,000 – $10,000','5000','10000'],['$10,000+','10000',null]],
'charge-controllers':[['Under $100',null,'100'],['$100 – $300','100','300'],['$300 – $500','300','500'],['$500+','500',null]],
'racking-mounting':[['Under $50',null,'50'],['$50 – $150','50','150'],['$150 – $500','150','500'],['$500+','500',null]],
'electrical-supplies':[['Under $25',null,'25'],['$25 – $100','25','100'],['$100 – $500','100','500'],['$500+','500',null]],
'commercial-standby-generators':[['Under $2,000',null,'2000'],['$2,000 – $5,000','2000','5000'],['$5,000 – $10,000','5000','10000'],['$10,000+','10000',null]],
'generators':[['Under $2,000',null,'2000'],['$2,000 – $5,000','2000','5000'],['$5,000 – $10,000','5000','10000'],['$10,000+','10000',null]],
'ev-chargers':[['Under $300',null,'300'],['$300 – $600','300','600'],['$600 – $1,000','600','1000'],['$1,000+','1000',null]]
};
var defaultPrices=[['Under $250',null,'250'],['$250 – $500','250','500'],['$500 – $1,000','500','1000'],['$1,000+','1000',null]];

function priceBuckets(h){
var rows=priceMap[h]||defaultPrices;
return rows.map(function(r){return {label:r[0],gte:r[1],lte:r[2]};});
}

function baseGroups(h){
return [
{name:'Price Range',type:'price',values:priceBuckets(h)},
{name:'Availability',type:'availability',values:[{label:'In Stock Only',param:'filter.v.availability',value:'1'}]}
];
}

var sidebarInflight=false;
function withConfig(h,cb){
if(sidebarInflight)return;
sidebarInflight=true;
var cacheKey='pes-fc2-'+h;
try{
var cached=sessionStorage.getItem(cacheKey);
if(cached){sidebarInflight=false;cb(JSON.parse(cached));return;}
}catch(e){}
fetch('/collections/'+h+'/products.json?limit=250')
.then(function(r){return r.ok?r.json():{products:[]};})
.then(function(d){
sidebarInflight=false;
var prods=d.products||[];
var vendorCounts={},typeCounts={},facetData=[];
prods.forEach(function(p){
if(p.vendor)vendorCounts[p.vendor]=(vendorCounts[p.vendor]||0)+1;
if(p.product_type)typeCounts[p.product_type]=(typeCounts[p.product_type]||0)+1;
// Lightweight facet row for count computation (Task C)
var price=null,avail=false;
(p.variants||[]).forEach(function(v){
var pr=parseFloat(v.price);
if(!isNaN(pr)&&(price===null||pr<price))price=pr;
if(v.available)avail=true;
});
facetData.push({v:p.vendor||'',t:p.product_type||'',p:price,a:avail});
});
var groups=[];
var types=Object.keys(typeCounts).sort(function(a,b){return typeCounts[b]-typeCounts[a];}).slice(0,10);
if(types.length>1)groups.push({name:'Type',type:'product_type',values:types});
var vendors=Object.keys(vendorCounts).sort(function(a,b){return vendorCounts[b]-vendorCounts[a];}).slice(0,12);
if(vendors.length)groups.push({name:'Brand',type:'vendor',values:vendors});
groups=groups.concat(baseGroups(h));
var config={groups:groups,facetData:facetData};
try{sessionStorage.setItem(cacheKey,JSON.stringify(config));}catch(e){}
cb(config);
})
.catch(function(){
sidebarInflight=false;
cb({groups:baseGroups(h),facetData:[]});
});
}

withConfig(handle,function(config){
if(!config)return;
/* === FACET COUNTS (Task C) — sibling-filter-aware ===
   Counts are computed client-side from the collection's products.json rows
   (first 250 products). Each group's counts respect the currently-applied
   filters from the OTHER groups (standard faceted-search behavior). */
var activeType=params.get('filter.p.product_type');
var availActive=params.get('filter.v.availability')==='1';
var fd=config.facetData||[];
function escHtml(s){return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');}
function passes(p,exclude){
if(exclude!=='vendor'&&activeVendor&&p.v!==activeVendor)return false;
if(exclude!=='type'&&activeType&&p.t!==activeType)return false;
if(exclude!=='price'){
if(activePriceGte&&(p.p===null||p.p<parseFloat(activePriceGte)))return false;
if(activePriceLte&&(p.p===null||p.p>parseFloat(activePriceLte)))return false;
}
if(exclude!=='availability'&&availActive&&!p.a)return false;
return true;
}
function facetCount(fn,exclude){
if(!fd.length)return -1;
var n=0;fd.forEach(function(p){if(fn(p)&&passes(p,exclude))n++;});
return n;
}
function countHtml(n){return n>=0?' <span class="count">('+n+')</span>':'';}

// Build sidebar HTML
var html='<div class="pes-sidebar">';
html+='<h3 class="pes-sidebar-title">Filters <span>Refine</span></h3>';

// Active filter chips
var hasActive=activeVendor||activePriceGte||activePriceLte||params.get('filter.v.availability')||params.get('filter.p.product_type');
if(hasActive){
html+='<div class="pes-active-filters">';
if(activeVendor){
html+='<a class="pes-filter-chip" href="'+clearParam('filter.p.vendor')+'">'+activeVendor+' <span class="x">×</span></a>';
}
if(activePriceGte||activePriceLte){
var plabel='';
if(activePriceGte&&activePriceLte)plabel='$'+activePriceGte+'–$'+activePriceLte;
else if(activePriceGte)plabel='$'+activePriceGte+'+';
else plabel='Under $'+activePriceLte;
html+='<a class="pes-filter-chip" href="'+clearParams(['filter.v.price.gte','filter.v.price.lte'])+'">'+plabel+' <span class="x">×</span></a>';
}
if(params.get('filter.p.product_type')){
html+='<a class="pes-filter-chip" href="'+clearParam('filter.p.product_type')+'">'+params.get('filter.p.product_type')+' <span class="x">×</span></a>';
}
if(params.get('filter.v.availability')){
html+='<a class="pes-filter-chip" href="'+clearParam('filter.v.availability')+'">In Stock <span class="x">×</span></a>';
}
html+='<a class="pes-clear-all" href="/collections/'+handle+'">Clear All</a>';
html+='</div>';
}

// Filter groups
config.groups.forEach(function(group,gi){
html+='<div class="pes-filter-group'+(gi>2?' collapsed':'')+'" data-group="'+gi+'">';
html+='<div class="pes-filter-group-header">'+group.name+'<span class="toggle">▾</span></div>';
html+='<ul class="pes-filter-list">';

if(group.type==='vendor'){
group.values.forEach(function(vendor){
var u='/collections/'+handle+'?filter.p.vendor='+encodeURIComponent(vendor);
var isActive=activeVendor===vendor;
var n=facetCount(function(p){return p.v===vendor;},'vendor');
html+='<li><a href="'+u+'"'+(isActive?' class="active"':'')+'>'+escHtml(vendor)+countHtml(n)+'</a></li>';
});
}else if(group.type==='price'){
group.values.forEach(function(pv){
var params2=new URLSearchParams();
if(pv.gte)params2.set('filter.v.price.gte',pv.gte);
if(pv.lte)params2.set('filter.v.price.lte',pv.lte);
var u='/collections/'+handle+'?'+params2.toString();
var n=facetCount(function(p){
if(p.p===null)return false;
if(pv.gte&&p.p<parseFloat(pv.gte))return false;
if(pv.lte&&p.p>parseFloat(pv.lte))return false;
return true;
},'price');
html+='<li><a href="'+u+'">'+pv.label+countHtml(n)+'</a></li>';
});
// Price input fields
html+='<li><div class="pes-price-inputs">';
html+='<input type="number" id="pes-price-min" placeholder="$ Min" aria-label="Minimum price" value="'+(activePriceGte||'')+'">';
html+='<span class="sep">–</span>';
html+='<input type="number" id="pes-price-max" placeholder="$ Max" aria-label="Maximum price" value="'+(activePriceLte||'')+'">';
html+='<button class="pes-price-go" onclick="var u=new URL(window.location.href);var mn=document.getElementById(\'pes-price-min\').value;var mx=document.getElementById(\'pes-price-max\').value;if(mn)u.searchParams.set(\'filter.v.price.gte\',mn);else u.searchParams.delete(\'filter.v.price.gte\');if(mx)u.searchParams.set(\'filter.v.price.lte\',mx);else u.searchParams.delete(\'filter.v.price.lte\');window.location.href=u.toString();">Go</button>';
html+='</div></li>';
}else if(group.type==='availability'){
group.values.forEach(function(av){
var u='/collections/'+handle+'?'+av.param+'='+av.value;
var isActive=params.get(av.param)===av.value;
var n=facetCount(function(p){return p.a;},'availability');
html+='<li><a href="'+u+'"'+(isActive?' class="active"':'')+'>'+av.label+countHtml(n)+'</a></li>';
});
}else if(group.type==='product_type'){
group.values.forEach(function(t){
var u='/collections/'+handle+'?filter.p.product_type='+encodeURIComponent(t);
var isActive=activeType===t;
var n=facetCount(function(p){return p.t===t;},'type');
html+='<li><a href="'+u+'"'+(isActive?' class="active"':'')+'>'+escHtml(t)+countHtml(n)+'</a></li>';
});
}else if(group.type==='tag'){
group.values.forEach(function(tv){
var u='/collections/'+handle+'/'+tv.tag;
html+='<li><a href="'+u+'">'+tv.label+'</a></li>';
});
}

html+='</ul>';
html+='</div>';
});

html+='</div>';

// Inject into container
container.innerHTML=html;
container.style.minHeight='auto';
container.style.padding='0';

// Add accordion toggle
container.querySelectorAll('.pes-filter-group-header').forEach(function(header){
header.addEventListener('click',function(){
var group=header.parentElement;
group.classList.toggle('collapsed');
});
});
// Mobile bottom-sheet filters (<=768px) — presentation shell reusing the same config + URL state (Task B).
// 769-989px remains owned by the legacy pes-collection-filters.js drawer.
buildFilterSheet(config,handle,{
activeVendor:activeVendor,activeType:activeType,
activePriceGte:activePriceGte,activePriceLte:activePriceLte,
availActive:availActive,facetCount:facetCount,escHtml:escHtml
});
});}

/* ========== MOBILE BOTTOM-SHEET FILTERS (<=768px, Task B) ========== */
function buildFilterSheet(config,handle,ctx){
if(!config||!config.groups)return;
// Don't rebuild while the shopper has the sheet open (init() re-runs on timers)
var existing=document.getElementById('pes-bs-sheet');
if(existing&&existing.classList.contains('open'))return;
var anchor=document.querySelector('.cstm-collect-facets-container');
if(!anchor)return;
var oldBar=document.getElementById('pes-bs-bar');if(oldBar)oldBar.remove();
var oldScrim=document.getElementById('pes-bs-scrim');if(oldScrim)oldScrim.remove();
if(existing)existing.remove();

var esc=ctx.escHtml;
// Active-count badge: one per active filter dimension
var activeCount=0;
if(ctx.activeVendor)activeCount++;
if(ctx.activeType)activeCount++;
if(ctx.activePriceGte||ctx.activePriceLte)activeCount++;
if(ctx.availActive)activeCount++;

// Staged selection (single-select per group, mirroring the desktop link model)
var staged={
vendor:ctx.activeVendor||null,
type:ctx.activeType||null,
avail:ctx.availActive||false
};

/* --- Trigger bar --- */
var bar=document.createElement('div');
bar.className='pes-bs-bar';bar.id='pes-bs-bar';
bar.innerHTML='<button type="button" class="pes-bs-btn" id="pes-bs-open" aria-haspopup="dialog">'
+'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="4" y1="21" x2="4" y2="14"></line><line x1="4" y1="10" x2="4" y2="3"></line><line x1="12" y1="21" x2="12" y2="12"></line><line x1="12" y1="8" x2="12" y2="3"></line><line x1="20" y1="21" x2="20" y2="16"></line><line x1="20" y1="12" x2="20" y2="3"></line><line x1="1" y1="14" x2="7" y2="14"></line><line x1="9" y1="8" x2="15" y2="8"></line><line x1="17" y1="16" x2="23" y2="16"></line></svg>'
+'<span>Filters</span>'
+(activeCount?'<span class="pes-bs-badge" aria-label="'+activeCount+' active filters">'+activeCount+'</span>':'')
+'</button>';
anchor.parentNode.insertBefore(bar,anchor);

/* --- Sheet markup --- */
var h='<div class="pes-bs-head"><h2>Filters</h2>'
+'<button type="button" class="pes-bs-close" aria-label="Close filters">&times;</button></div>';
h+='<div class="pes-bs-body">';
config.groups.forEach(function(group){
h+='<div class="pes-bs-group">';
h+='<div class="pes-bs-group-name">'+esc(group.name)+'</div>';
h+='<ul class="pes-bs-list">';
if(group.type==='vendor'){
group.values.forEach(function(vendor){
var n=ctx.facetCount(function(p){return p.v===vendor;},'vendor');
h+='<li><button type="button" class="pes-bs-opt'+(staged.vendor===vendor?' selected':'')+'" data-kind="vendor" data-value="'+esc(vendor)+'"><span>'+esc(vendor)+'</span>'+(n>=0?'<span class="cnt">('+n+')</span>':'')+'</button></li>';
});
}else if(group.type==='product_type'){
group.values.forEach(function(t){
var n=ctx.facetCount(function(p){return p.t===t;},'type');
h+='<li><button type="button" class="pes-bs-opt'+(staged.type===t?' selected':'')+'" data-kind="type" data-value="'+esc(t)+'"><span>'+esc(t)+'</span>'+(n>=0?'<span class="cnt">('+n+')</span>':'')+'</button></li>';
});
}else if(group.type==='price'){
group.values.forEach(function(pv){
var n=ctx.facetCount(function(p){
if(p.p===null)return false;
if(pv.gte&&p.p<parseFloat(pv.gte))return false;
if(pv.lte&&p.p>parseFloat(pv.lte))return false;
return true;
},'price');
h+='<li><button type="button" class="pes-bs-opt" data-kind="price" data-gte="'+(pv.gte||'')+'" data-lte="'+(pv.lte||'')+'"><span>'+esc(pv.label)+'</span>'+(n>=0?'<span class="cnt">('+n+')</span>':'')+'</button></li>';
});
h+='<li><div class="pes-bs-price-inputs">'
+'<input type="number" id="pes-bs-price-min" placeholder="$ Min" value="'+(ctx.activePriceGte||'')+'" aria-label="Minimum price">'
+'<span class="sep">–</span>'
+'<input type="number" id="pes-bs-price-max" placeholder="$ Max" value="'+(ctx.activePriceLte||'')+'" aria-label="Maximum price">'
+'</div></li>';
}else if(group.type==='availability'){
group.values.forEach(function(av){
var n=ctx.facetCount(function(p){return p.a;},'availability');
h+='<li><button type="button" class="pes-bs-opt'+(staged.avail?' selected':'')+'" data-kind="availability"><span>'+esc(av.label)+'</span>'+(n>=0?'<span class="cnt">('+n+')</span>':'')+'</button></li>';
});
}
h+='</ul></div>';
});
h+='</div>';
h+='<div class="pes-bs-foot">'
+'<button type="button" class="pes-bs-clear">Clear All</button>'
+'<button type="button" class="pes-bs-apply">Apply Filters</button>'
+'</div>';

var scrim=document.createElement('div');
scrim.className='pes-bs-scrim';scrim.id='pes-bs-scrim';
var sheet=document.createElement('div');
sheet.className='pes-bs-sheet';sheet.id='pes-bs-sheet';
sheet.setAttribute('role','dialog');
sheet.setAttribute('aria-modal','true');
sheet.setAttribute('aria-label','Filters');
sheet.innerHTML=h;
document.body.appendChild(scrim);
document.body.appendChild(sheet);

/* --- Behavior --- */
var openBtn=document.getElementById('pes-bs-open');
var lastFocus=null;

// Mark the price bucket matching current URL params
sheet.querySelectorAll('.pes-bs-opt[data-kind="price"]').forEach(function(btn){
var g=btn.getAttribute('data-gte'),l=btn.getAttribute('data-lte');
if((ctx.activePriceGte||'')===g&&(ctx.activePriceLte||'')===l&&(g||l))btn.classList.add('selected');
});

sheet.querySelectorAll('.pes-bs-opt').forEach(function(btn){
btn.addEventListener('click',function(){
var kind=btn.getAttribute('data-kind');
if(kind==='vendor'||kind==='type'){
var val=btn.getAttribute('data-value');
var wasSelected=btn.classList.contains('selected');
sheet.querySelectorAll('.pes-bs-opt[data-kind="'+kind+'"]').forEach(function(b){b.classList.remove('selected');});
staged[kind]=wasSelected?null:val;
if(!wasSelected)btn.classList.add('selected');
}else if(kind==='availability'){
staged.avail=!staged.avail;
btn.classList.toggle('selected',staged.avail);
}else if(kind==='price'){
var wasSelected=btn.classList.contains('selected');
sheet.querySelectorAll('.pes-bs-opt[data-kind="price"]').forEach(function(b){b.classList.remove('selected');});
var mn=sheet.querySelector('#pes-bs-price-min'),mx=sheet.querySelector('#pes-bs-price-max');
if(wasSelected){
if(mn)mn.value='';if(mx)mx.value='';
}else{
btn.classList.add('selected');
if(mn)mn.value=btn.getAttribute('data-gte');
if(mx)mx.value=btn.getAttribute('data-lte');
}
}
});
});
// Typing a custom price deselects bucket presets
['#pes-bs-price-min','#pes-bs-price-max'].forEach(function(sel){
var inp=sheet.querySelector(sel);
if(inp)inp.addEventListener('input',function(){
sheet.querySelectorAll('.pes-bs-opt[data-kind="price"]').forEach(function(b){b.classList.remove('selected');});
});
});

function openSheet(){
lastFocus=document.activeElement;
scrim.classList.add('open');
sheet.classList.add('open');
document.body.classList.add('pes-bs-locked');
var first=sheet.querySelector('.pes-bs-close');
if(first)first.focus();
}
function closeSheet(){
scrim.classList.remove('open');
sheet.classList.remove('open');
document.body.classList.remove('pes-bs-locked');
if(lastFocus&&lastFocus.focus)lastFocus.focus();
else if(openBtn)openBtn.focus();
}
openBtn.addEventListener('click',openSheet);
scrim.addEventListener('click',closeSheet);
sheet.querySelector('.pes-bs-close').addEventListener('click',closeSheet);

// Esc + focus trap
document.addEventListener('keydown',function(e){
if(!sheet.classList.contains('open'))return;
if(e.key==='Escape'){closeSheet();return;}
if(e.key!=='Tab')return;
var focusable=sheet.querySelectorAll('button, input, [tabindex]:not([tabindex="-1"])');
if(!focusable.length)return;
var first=focusable[0],last=focusable[focusable.length-1];
if(e.shiftKey&&document.activeElement===first){e.preventDefault();last.focus();}
else if(!e.shiftKey&&document.activeElement===last){e.preventDefault();first.focus();}
});

sheet.querySelector('.pes-bs-clear').addEventListener('click',function(){
window.location.href='/collections/'+handle;
});
sheet.querySelector('.pes-bs-apply').addEventListener('click',function(){
var u=new URL(window.location.href);
['filter.p.vendor','filter.p.product_type','filter.v.price.gte','filter.v.price.lte','filter.v.availability'].forEach(function(k){u.searchParams.delete(k);});
if(staged.vendor)u.searchParams.set('filter.p.vendor',staged.vendor);
if(staged.type)u.searchParams.set('filter.p.product_type',staged.type);
var mn=sheet.querySelector('#pes-bs-price-min'),mx=sheet.querySelector('#pes-bs-price-max');
if(mn&&mn.value)u.searchParams.set('filter.v.price.gte',mn.value);
if(mx&&mx.value)u.searchParams.set('filter.v.price.lte',mx.value);
if(staged.avail)u.searchParams.set('filter.v.availability','1');
window.location.href=u.toString();
});
}

function clearParam(paramName){
var u=new URL(window.location.href);
u.searchParams.delete(paramName);
return u.toString();
}
function clearParams(paramNames){
var u=new URL(window.location.href);
paramNames.forEach(function(p){u.searchParams.delete(p);});
return u.toString();
}

/* ========== SUBNAV ACTIVE STATE ========== */
function fixSubnav(){
var items=document.querySelectorAll('.collection-subnavigation__item, .pes-subnav-item');
if(!items.length)return;
var path=window.location.pathname.toLowerCase();
items.forEach(function(item){
var link=item.querySelector('a');
if(link){
var href=link.getAttribute('href');
if(href&&path.indexOf(href.toLowerCase())>=0){item.classList.add('active');}
else{item.classList.remove('active');}
}
});
}

/* ========== BROWSE BUBBLE ========== */
function removeBrowseBubble(){
var b=document.querySelectorAll('[class*="browse-bubble"]');
b.forEach(function(e){e.style.display='none';});
}

/* ========== FORCE SIDEBAR VISIBLE (desktop only) ========== */
function forceSidebarVisible(){
if(window.innerWidth<=989){
// Mobile/tablet: never force the desktop sidebar open. Let the drawer CSS/JS (pes-collection-filters.js, breakpoint 989px) own visibility.
return;
}
var sf=document.querySelector('.cust-desktop-sortfilter');
if(sf){
sf.style.setProperty('display','block','important');
sf.style.setProperty('width','260px','important');
sf.style.setProperty('min-width','260px','important');
sf.style.setProperty('flex-shrink','0','important');
sf.style.setProperty('position','sticky','important');
sf.style.setProperty('top','80px','important');
sf.style.setProperty('max-height','calc(100vh - 100px)','important');
sf.style.setProperty('overflow-y','auto','important');
sf.style.setProperty('visibility','visible','important');
sf.style.setProperty('opacity','1','important');
}
var fc=document.querySelector('.cstm-collect-facets-container');
if(fc){
fc.style.setProperty('display','flex','important');
fc.style.setProperty('gap','24px','important');
fc.style.setProperty('align-items','flex-start','important');
}
var grid=document.querySelector('.collection_main_grid');
if(grid){
grid.style.setProperty('flex','1','important');
grid.style.setProperty('min-width','0','important');
}
}

/* ========== INIT ========== */
function init(){
injectCSS();
forceSidebarVisible();
initSortDropdown();
fixSubnav();
removeBrowseBubble();
buildSidebar();
forceSidebarVisible();
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}
else{init();}
setTimeout(function(){init();},500);
setTimeout(function(){init();},2000);
setTimeout(function(){init();},4000);
document.addEventListener('shopify:section:load',init);

// MutationObserver to keep sidebar visible if other scripts hide it
if(typeof MutationObserver!=='undefined'){
var mo=new MutationObserver(function(){forceSidebarVisible();});
if(document.body)mo.observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['style','class']});
}
})();
